/* import __COLOCATED_TEMPLATE__ from './topology-container.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

import Utils from '../utils/utils';

export default class TopologyContainer extends Component {
  @service intl;
  @service adiStyleService;
  @service validationService;
  @service('aditools-analytics') analytics;

  @action onTopologySelection(input, value) {
    input.selectedOption = value;
    this.args.model.markAsNotReady();
    this.args.model.handleTopologyChange(input);

    if (this.args.updateAppData) this.args.updateAppData();

    this.args.model.markAsReady();

    this.analytics.setWebEvent(
      Utils.getToolName(),
      'selectTopology',
      `${input.config.name}: ${input.selectedOption.id}`,
    );
  }

  updateElementMinHeight() {
    let childElements = Object.values(this.element.children).filter(
      (childElement) =>
        !Object.values(childElement.classList).includes('adi-select-container'),
    );
    const propertyName = 'min-height';
    const selector = `#${this.elementId}`;
    const elementMinHeight = this.adiStyleService.getValueForSelectorProperty(
      selector,
      propertyName,
    );
    const extraHeight = 30; // padding and border

    // (accumulator, currentValue, currentIndex, array)
    const totalHeight = childElements
      .map((childElement) => childElement.offsetHeight)
      .reduce((accumulator, currentValue) => accumulator + currentValue);

    const propertyValue = `${totalHeight + extraHeight}px !important`;

    if (!(propertyValue === elementMinHeight)) {
      let properties = {};
      properties[propertyName] = propertyValue;

      this.adiStyleService.insertRule({
        selector: selector,
        properties: properties,
      });
    }
  }
}
